import { h } from 'preact'
import Button from 'components/Button'
import Icon from 'components/Icon'
import ChatChannelAvatar from 'components/ChatChannelAvatar'
import { useJoinChatChannel } from 'lib/chatHooks'

export function JoinChat({ chatChannelUid, chatName, onJoin, chatChannel }) {
  const joinChatChannel = useJoinChatChannel('OrganizationChatPage')

  const handleJoinChat = async () => {
    try {
      // Call the joinChatChannel hook to join the channel
      await joinChatChannel(chatChannelUid)

      // After successful join, call the onJoin callback
      if (onJoin) {
        onJoin(chatChannelUid)
      }
    } catch (error) {
      console.error('Failed to join chat channel:', error)
      // Optionally add error handling UI here
    }
  }

  return (
    <div className="OrganizationChatPage-ChatWindow-join-container">
      <div className="OrganizationChatPage-ChatWindow-join-message">
        <div className="OrganizationChatPage-ChatWindow-join-icon">
          <ChatChannelAvatar size="sm" value={
            chatChannel.imageUrl?.startsWith('#') ?
              <div className={'avatarImg'}>
                <Icon type="chaty" />
              </div> :
              <img
                src={chatChannel.imageUrl}
                alt="Chat Image"
                className={'avatarImg'}
                style={{ padding: 0, margin:'0 1rem' }}
              />
          } />
          <p className="join-description">
            <span className="chat-name"> <Icon type="public" />{chatName || 'Public Chat'}</span>
            <br />
                        This is a public chat.
            <br />
                        Click "Join Chat" to start messaging, or "Chat Info" for more details.
          </p>
        </div>

        <div className="join-actions">
          {/* <Button
                        type="normal"
                        onClick={() => {
                            // Add logic to show chat info
                        }}
                    >
                        Chat Info
                    </Button> */}
          <Button
            type="primary"
            onClick={handleJoinChat}
          >
                        Join Chat
          </Button>
        </div>
      </div>
    </div>
  )
}
